import { Link } from "react-router-dom";
import {
  IconFolder,
  IconLayers,
  IconPackage,
  IconUsers,
} from "../icons";

const QUICK_LINKS = [
  {
    to: "/admin/dashboard/users",
    title: "Users",
    description: "Manage admin accounts and access",
    icon: IconUsers,
  },
  {
    to: "/admin/dashboard/categories",
    title: "Categories",
    description: "Organise scheme feature categories",
    icon: IconFolder,
  },
  {
    to: "/admin/dashboard/scheme-features",
    title: "Scheme Features",
    description: "Edit features, descriptions, and panel items",
    icon: IconLayers,
  },
  {
    to: "/admin/dashboard/addons",
    title: "Addons",
    description: "Configure product addons",
    icon: IconPackage,
  },
];

export default function DashboardHome() {
  return (
    <div className="dashboard-home">
      <div className="dashboard-home__grid">
        {QUICK_LINKS.map(({ to, title, description, icon: Icon }) => (
          <Link key={to} to={to} className="dashboard-home__card">
            <span className="dashboard-home__card-icon">
              <Icon size={22} />
            </span>
            <div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
